import { h } from 'preact';
export const TrendingUp = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "23 6 13.5 15.5 8.5 10.5 1 18" }),
        h("polyline", { points: "17 6 23 6 23 12" })));
};
//# sourceMappingURL=trending-up.js.map